export default "__VITE_ASSET__BFwPIXiG__"